import { IState } from "../state";

export class Vessels {
  static followAlarms(state: IState, data: { vesselId: string; alarmIds: number[] }) {
    const newState = Object.assign({}, state);

    newState.followedAlarms[data.vesselId] = [...data.alarmIds];

    return newState;
  }
}
